//React
import React from "react";
import {
  Link,
  NavLink,
} from "react-router-dom";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myProfileAction from '../action/myProfileAction';
import * as timelineAction from '../action/timelineAction';
import * as helpAction from '../action/helpAction';
import * as guideAction from '../action/guideAction';
//Material-ui
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
//Add
import moment from 'moment';

//Icon
import { FaComments } from 'react-icons/fa';
import PetsIcon from '@material-ui/icons/Pets';
import StarRoundedIcon from '@material-ui/icons/StarRounded';
import HelpOutlineRoundedIcon from '@material-ui/icons/HelpOutlineRounded';

import SearchIcon from '@material-ui/icons/Search';
import MailIcon from '@material-ui/icons/Mail';
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle';
import SettingsRoundedIcon from '@material-ui/icons/SettingsRounded';
import LocalCafeRoundedIcon from '@material-ui/icons/LocalCafeRounded';
import LocalOfferRoundedIcon from '@material-ui/icons/LocalOfferRounded';
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone';
//Part
import PartUserName from './PartUserName';
import PartUserMainImg from './PartUserMainImg';

import PartTimeline from './PartTimeline';
import PartNavigatior from './PartNavigatior';
import PartCoupleRequest from './PartCoupleRequest';
import PartCoupleReception from './PartCoupleReception';
import PartCouple from './PartCouple';


class Comp extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      rwdModeConfirm: false,
    }
  }


  componentDidMount() {
    document.title = 'ホーム - パートナーズ';
    if (this.props.history.action === 'PUSH') {
      window.scrollTo(0, 0);
    }
  }

  render() {
    let chargeComp= null;
    if (this.props.my.profile.userdata_sex === 'men') {
      let startDate = moment.unix(this.props.my.setting.chargeStart);
      let endDate =  moment.unix(this.props.my.setting.chargeEnd);
      let nowDate =  moment();

      if (nowDate.isBetween(startDate , endDate )) {
        chargeComp = (
          <div align='center' style={{padding:'5px'}}>
              <span
                className='orange-o_icon link'
                onClick={ () => this.props.history.push('/setting/#chargeBlock') }
              >
                有料サービス
              </span>
              <span className='i-b' style={{marginLeft:'5px', fontSize:'0.9em'}}>
                <u className='link' onClick={ () => this.props.history.push('/setting/#chargeBlock') }>有料サービスの期日</u>
              </span>

          </div>
        )
      }
      else {
        let partChargeEnd = null;
        let partApproachMail = null;
        if (this.props.my.proof.person === 1) {
          partApproachMail = (
            <div style={{margin:'5px'}}>
              <div style={{fontSize:'0.9em', color:'#666'}}>
                無料のアプローチメールは1人のお相手に
                {
                  (this.props.my.proof.person + (this.props.my.photo.main.uriCrop ? 1 : 0) + this.props.my.proof.photo + this.props.my.proof.income + this.props.my.proof.single + this.props.my.proof.credit)
                }
                通まで送れます。
              </div>
              {
                ((this.props.my.proof.person + (this.props.my.photo.main.uriCrop ? 1 : 0) + this.props.my.proof.photo + this.props.my.proof.income + this.props.my.proof.single + this.props.my.proof.credit) < 5) && (
                  <div style={{fontSize:'0.9em', color:'#666'}}>
                    {
                      (!this.props.my.photo.main.uriCrop) && (
                        <>
                          <Link to="/my/" style={{textDecorationLine:'underline'}}>
                            メイン写真を掲載
                          </Link>
                          いただくか、
                        </>
                      )
                    }
                    <span className='link' onClick={ () => this.props.history.push('/my/proof/') }><u>証明書を追加</u></span>
                    すると最大5通まで増えます。
                  </div>
                )
              }
            </div>
          );
        }
        else {
          partApproachMail = (
            <div style={{margin:'5px', fontSize:'0.9em', color:'#666'}}>
              <span className='link' onClick={ () => this.props.history.push('/my/proof/person') }><u>本人証明を申請</u></span>するとアプローチメールが送信できます。
            </div>
          );
        }


        if (this.props.my.setting.chargeEnd) {
          partChargeEnd = (
            <div>
              <span className='black_icon'>有料サービス終了</span>
              <span className='i-b' style={{marginLeft:'5px', fontSize:'0.9em'}}>
                <u className='link' onClick={ () => this.props.history.push('/setting/#chargeBlock') }>有料サービスの期日</u>
              </span>
            </div>
          );
        }

        let partChargeLink = (
          <div style={{margin:'5px'}}>
            <span style={{fontSize:'0.9em'}}>
              無制限に利用するなら
            </span>
            <Button
              variant="outlined"
              color='primary'
              onClick={ () => this.props.history.push('/setting/charge/') }
              style={{marginLeft:'5px'}}
            >
              有料サービスはこちら
            </Button>
          </div>
        );

        chargeComp = (
          <div style={{margin:'5px'}}>

            {partChargeEnd}
            <span
              className='orange-o_icon link'
              onClick={ () => this.props.history.push('/setting/charge/') }
            >
              無料サービス
            </span>
            {partApproachMail}
            {partChargeLink}
          </div>
        )
      }

    }

    return (
      <div id='loginTop_block'>

        <div className='col2_left'>

          <Box boxShadow={2} style={{background:'#FFF'}}>
            <div style={{padding:'10px'}}>
              <Button
                color="primary"
                variant={ "outlined" }
                onClick={ () => this.props.guideAppSet(true) }
                style={{width:'100%'}}
              >
                <div>
                  <span className='red_icon' style={{fontSize:'0.8em',marginRight:10}}>おすすめ</span>
                  <span className='i-b'>超簡単ワンクリックでアプリに切り替え！</span>
                </div>
              </Button>
            </div>
          </Box>

          <Box boxShadow={2} style={{background:'#FFF', marginTop:'10px', position:'relative'}}>
            <IconButton
              onClick={ () => this.props.history.push('/news/') }
              style={{position:'absolute', top:0, left:0}}
            >
                <NotificationsNoneIcon style={{color:'#999', fontSize:'1.2em'}} className='icon' />
              {
                (this.props.notification.newsUnread > 0) &&
                <span style={{position:'absolute',top:'1px',right:'5px'}}>
                  <span className='badge'></span>
                </span>
              }
            </IconButton>
            <div id='home_profile' align='center'>
              <div className='table' style={{marginTop:'10px'}}>
                <div className='box' id='mainImg' style={{textAlign:'center'}} >

                  <Link to={{ pathname: '/my/'}} >
                    <PartUserMainImg
                      mainImg={{
                        bool: true,
                        quit: false,
                        sex: this.props.my.profile.userdata_sex,
                        src: this.props.my.photo.main.uriCrop,
                        stop: false
                      }}
                      maxWidth={'60px'}
                      width={'100%'}
                      height={'auto'}
                      radius={'50%'}

                    />
                  </Link>
                </div>
                <div className='box'  style={{textAlign:'center'}}>
                  <Link to={{ pathname: '/my/'}}>
                    <PartUserName
                      data={{
                        name: this.props.my.profile.userdata_name,
                        sex: this.props.my.profile.userdata_sex,
                        size: '1.6em',
                      }}
                    />
                  </Link>
                </div>
              </div>

              <div className='table'>

                <div className='box'>
                  <div style={{margin:'5px 0px', whiteSpace:'nowrap'}}>
                    <Button
                      variant="outlined"
                      style={{width:'100%', paddingLeft:'8px', paddingRight:'8px', fontSize:'1em'}}
                      onClick={ () => this.props.history.push('/my/') }
                    >
                      プロフィール
                    </Button>
                  </div>
                </div>

                <div className='box'>
                  <div style={{margin:'5px 0px', whiteSpace:'nowrap'}}>
                    <ButtonGroup fullWidth={true} >
                      <Button
                        style={{fontSize:'1em'}}
                        onClick={ () => this.props.history.push('/my/post/') }
                      >
                        投稿
                      </Button>
                      <Button
                        style={{fontSize:'1em'}}
                        onClick={ () => this.props.history.push('/my/qa/question/') }
                      >
                        Q&A
                      </Button>
                      <Button
                        style={{fontSize:'1em'}}
                        onClick={ () => this.props.history.push('/my/personality/') }
                      >
                        性格
                      </Button>
                    </ButtonGroup>
                  </div>

                </div>
              </div>

              <div align='center'>

                { chargeComp }
              </div>
            </div>


            <PartNavigatior className='left'/>

            <div id='home_menu'>
              <div className='menu'>
            		<div className='outer' style={{padding:'5px'}}>

            			<div className='inner'>
            				<div className='table'>
            					<div className='box col1'>
                        <NavLink to="/mailbox/" className='link'>
                          <MailIcon style={{color:'#FFAA57'}} className='icon'/>
                          <span className='text'>メールボックス</span>
                          {
                            (this.props.notification.mailUnconfirmed > 0) &&
                            <span style={{position:'absolute',top:'3px',left:'0px',right:'0px',margin:'auto',marginLeft:'28px',}}>
                              <span className='badge'>{this.props.notification.mailUnconfirmed}</span>
                            </span>
                          }
                        </NavLink>
                      </div>
                      <div className='box col1'>
                        <NavLink to="/bestpartner/" className='link'>
                          <SupervisedUserCircleIcon style={{color:'#4376AB', paddingRight:'0px', marginRight:'0px'}} className='icon'/>
                          <span className='text'>パートナー紹介</span>
                          {
                            (this.props.notification.bestpartnerUnconfirmed > 0) &&
                            <span style={{position:'absolute',top:'3px',left:'0px',right:'0px',margin:'auto',marginLeft:'28px',}}>
                              <span className='badge'>{this.props.notification.bestpartnerUnconfirmed}</span>
                            </span>
                          }
                        </NavLink>
                      </div>
                      <div className='box col1'>
                        <NavLink to="/search/" className='link'>
                          <SearchIcon style={{color:'#E65162'}} className='icon' />
                          <span className='text'>会員検索</span>
                        </NavLink>
                      </div>
                      <div className='box col1'>
                        <NavLink to="/footprint/partner/" className='link'>
                          <PetsIcon style={{color:'#C79D61'}} className='icon' />
                          <span className='text'>足あと</span>
                        </NavLink>
                      </div>
                      <div className='box col1'>
                        <NavLink to="/favorite/my/" className='link'>
                          <StarRoundedIcon style={{color:'#F95561'}} className='icon' />
                          <span className='text'>お気に入り</span>
                          {
                            (this.props.notification.favoriteNoticeUnconfirmed > 0) &&
                            <span style={{position:'absolute',top:'3px',left:'0px',right:'0px',margin:'auto',marginLeft:'28px',}}>
                              <span className='badge'>{this.props.notification.favoriteNoticeUnconfirmed}</span>
                            </span>
                          }
                        </NavLink>
                      </div>
                      <div className='box col1'>
                        <NavLink to="/community/post/" className='link'>
                          <FaComments style={{color:'#3BAD8B'}} className='icon' />
                          <span className='text'>みんなの…</span>
                        </NavLink>
                      </div>
                      <div className='box col1'>
                        <NavLink to="/memo/" className='link'>
                          <LocalOfferRoundedIcon style={{color:'#84A77F'}} className='icon' />
                          <span className='text'>メモ帳</span>
                        </NavLink>
                      </div>
                      <div className='box col1'>
                        <NavLink to="/articles/" className='link'>
                          <LocalCafeRoundedIcon style={{color:'#3B8FA3'}} className='icon' />
                          <span className='text'>コラム</span>
                        </NavLink>
                      </div>
                      <div className='box col1'>
                        <NavLink to="/help/" className='link'>
                          <HelpOutlineRoundedIcon style={{color:'#E54E7C'}} className='icon' />
                          <span className='text'>ヘルプ</span>
                        </NavLink>
                      </div>
                      <div className='box col1'>
                        <NavLink to="/setting/" className='link'>
                          <SettingsRoundedIcon style={{color:'#777'}} className='icon' />
                          <span className='text'>設定</span>
                        </NavLink>
                      </div>
            				</div>
            			</div>
            		</div>
            	</div>
            </div>
          </Box>




        </div>


        <div className='col2_right'>
          <PartNavigatior className='right'/>

          <PartCoupleRequest />
          {
            (this.props.notification.coupleReception) && (
              <div className='couple_block'>
                {
                  this.props.notification.coupleReception.map((value, index, arr) => (
                    <PartCoupleReception key={index} value={value} />
                  ))
                }
              </div>
            )
          }
          <PartCouple />


          {
            (this.props.my.setting.serviceStop !== 1) && (
              <PartTimeline />
            )
          }

        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
	return {
    my: state.my,
    notification: state.notification,
    timeline: state.timeline,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myProfileAction,
    ...timelineAction,
    ...helpAction,
    ...guideAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
